<template>
  <NButtonToggleGroup
    v-model="selectedFilterIndex"
    v-gid="{
      module: 'orderTables',
      screen: 'home',
      section: 'ordersFilterToggle',
      component: 'ordersFilterToggleGroup',
    }"
    color="gray"
    dir="rtl"
    class="flex items-start my-1 mx-1"
  >
    <NButtonToggle
      v-for="{ label, value } in ORDER_FILTER_OPTIONS"
      :key="value"
      v-gid="{
        module: 'orderTables',
        screen: 'home',
        section: `${value}OrderTab`,
        component: `${value}OrderTableTab`,
      }"
      :label="`${label} (${orderCounts[value]})`"
    >
      <template #label>
        <span class="text-o font-medium leading-[0]">
          {{ `${label} (${orderCounts[value]})` }}
        </span>
      </template>
    </NButtonToggle>
  </NButtonToggleGroup>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue';
import { getFilteredOrders } from '@core/order';
import { OrderItem } from '@libs/api-reference';

import { ORDER_FILTER_OPTIONS } from '../../constants';

type OrdersTableToggleProps = {
  modelValue: string;
  orders: OrderItem[];
};

type OrdersTableToggleEmits = {
  (e: 'update:modelValue', value: string): void;
};

const props = defineProps<OrdersTableToggleProps>();
const emit = defineEmits<OrdersTableToggleEmits>();

const selectedFilterIndex = computed({
  get: () => {
    const index = ORDER_FILTER_OPTIONS.findIndex(
      (filter) => filter.value === props.modelValue
    );

    return index === -1 ? 0 : index;
  },
  set: (index: number) => {
    emit('update:modelValue', ORDER_FILTER_OPTIONS[index].value);
  },
});
onMounted(() => {
  emit('update:modelValue', ORDER_FILTER_OPTIONS[0].value);
});

const orderCounts = computed(() =>
  ORDER_FILTER_OPTIONS.reduce<Record<string, number>>((counts, { value }) => {
    counts[value] = getFilteredOrders(props.orders, value).length;

    return counts;
  }, {})
);
</script>
